<template>
    <div class="full-screen" id="advertiserContainer">
      <div class="advertiser__container full-screen">
          <SideMenu/>
          <router-view/>
      </div>
      <footer-view style="border-top: 1px solid;"></footer-view>
    </div>
</template>

<script>
import SideMenu from './../menu/SideMenu.vue' 
import FooterView from '@components/footer/FooterView.vue'

export default {
  name: 'Advertiser',
  components: {
    SideMenu,
    FooterView
  }
}
</script>

<style scoped>
.advertiser__container{
  min-height: 100vh;
}
</style>
